module.exports = __webpack_public_path__ + "img/Liberation.3225679c.svg";